import React from 'react';
import Step from './Step';
import ExpandableContainer from './ExpandableContainer';
import StepHorizontalField from './StepHorizontalField';
import StepModel from '../../../model/configurator/StepModel';
import Field from '../../../model/configurator/Field';
import CrossReferencedHeatingField from '../../../model/configurator/controller/CrossReferencedHeatingField';
import CrossReferencedPSEField from '../../../model/configurator/primarySideEquipment/CrossReferencedPSEField';
import Warning from '../../common/Warning';

export default class StepController extends Step {

    renderGeneralOptionsSection = () => {
        const warnings = [
            this.fields.controlCenter.warning,
        ];


        if (!this.renderSection(this.fields.controller,
            this.fields.pumpSwitchBox,
            this.fields.controlCenter,
            this.fields.router,
            this.fields.addOnOption4,
            this.fields.addOnOption3,
            this.fields.addOnOption2,
            this.fields.addOnOption1,
            this.fields.upgradedControllerDisplay,
            this.fields.controllerManufacturerFilter
        ))
            return (<React.Fragment></React.Fragment>)

        return (
            <ExpandableContainer warnings={warnings} label={__('General options')} initialOpen={true}>
                <div className="row row-no-outer-gutter">
                    <div className="column-8 column-xs-12">
                        {this.renderGenericHorizontalField(this.fields.controllerManufacturerFilter)}
                        {this.renderControlCenterField()}
                        {this.renderGenericHorizontalField(this.fields.controller)}
                        {this.renderGenericHorizontalField(this.fields.pumpSwitchBox)}
                        {this.renderGenericHorizontalField(this.fields.upgradedControllerDisplay)}
                        {this.renderGenericHorizontalField(this.fields.addOnOption1)}
                        {this.renderGenericHorizontalField(this.fields.addOnOption2)}
                        {this.renderGenericHorizontalField(this.fields.addOnOption3)}
                        {this.renderGenericHorizontalField(this.fields.addOnOption4)}
                        {this.renderGenericHorizontalField(this.fields.router)}
                        {this.renderReferenceTemperatureSensor()}
                    </div>
                </div>
            </ExpandableContainer>
        )
    }

    renderReferenceTemperatureSensor() {
        const renderCount = () => {
            return (
                <div className="flex-center-v w-100">
                    <div style={{flex: 1, marginLeft: '10px', marginRight: '10px'}}>
                        {this.renderFieldv2(this.fields.refSensCount)}
                    </div>

                    <div>{__('pcs')}</div>
                </div>
            )
        }

        return (
            <StepHorizontalField className="reference-temp-sensor" label={this.fields.referenceTemperatureSensor.label}
                                 visible={this.fields.referenceTemperatureSensor.visible}>
                {this.fields.refSensCount.visible ? (
                    <div style={{display: 'flex'}}>
                        {this.renderFieldv2(this.fields.referenceTemperatureSensor)}
                        {renderCount()}
                    </div>
                ) : (
                    <div>{this.renderFieldv2(this.fields.referenceTemperatureSensor)}</div>
                )}
            </StepHorizontalField>
        )
    }

    renderControlCenterField = () => {
        return (
            <React.Fragment>
                {this.renderGenericHorizontalField(this.fields.controlCenter)}
                {this.fields.controlCenter.value == null &&

                    <span className="control-center-warning">
                        <div className="configuration-editor-input-wrapper">
                            <span className="input-warning-tooltip">
                                <Warning warning={this.fields.controlCenter.warning}/>
                            </span>
                        </div>
                    </span>
                }

            </React.Fragment>

        )

    }

    renderTemperatureSensorsSection = () => {
        const primarySideEquipmentVisible = [this.fields.tedhFlow, this.fields.tedhRet].some(x => x.visible);
        const flowTemperatureSensorReadonly = [this.fields.flowTemperatureSensor1, this.fields.flowTemperatureSensor2, this.fields.flowTemperatureSensor3].filter(x => x.visible).every(x => x.readonly);
        const returnTemperatureSensorReadonly = [this.fields.returnTemperatureSensor1, this.fields.returnTemperatureSensor2, this.fields.returnTemperatureSensor3].filter(x => x.visible).every(x => x.readonly);
        const temperatureSensorPrimaryReturnReadonly = [this.fields.temperatureSensorPrimaryReturn1, this.fields.temperatureSensorPrimaryReturn2, this.fields.temperatureSensorPrimaryReturn3].filter(x => x.visible).every(x => x.readonly);

        const jointFlowTemperatureSensors = [this.fields.jointFlowTemperatureSensor1, this.fields.jointFlowTemperatureSensor2, this.fields.jointFlowTemperatureSensor3].filter(x => x.visible);
        const jointReturnTemperatureSensors = [this.fields.jointReturnTemperatureSensor1, this.fields.jointReturnTemperatureSensor2, this.fields.jointReturnTemperatureSensor3].filter(x => x.visible);

        return (
            <ExpandableContainer label={__('Temperature sensors')}>
                <div className="row row-no-outer-gutter">
                    <div className="column-12 column-xs-12 sensors">
                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={this.fields.temperatureSensorManufacturer.readonly}
                                             label={this.fields.temperatureSensorManufacturer.label}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.temperatureSensorManufacturer)}
                                </div>
                            </div>
                        </StepHorizontalField>
                    </div>
                </div>
                <div className="row row-no-outer-gutter ">
                    <div className="column-12 column-xs-12 sensors">

                        <StepHorizontalField label='' className="controller-heating-sensor">
                            <div className="row row-no-outer-gutter w-100 left-0">

                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(1)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(2)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={flowTemperatureSensorReadonly}
                                             label={this.renderLabel(1, 'flowTemperatureSensor')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowTemperatureSensor1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowTemperatureSensor2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowTemperatureSensor3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={returnTemperatureSensorReadonly}
                                             label={this.renderLabel(1, 'returnTemperatureSensor')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnTemperatureSensor1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnTemperatureSensor2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnTemperatureSensor3)}
                                </div>
                            </div>
                        </StepHorizontalField>
                        {jointFlowTemperatureSensors.length > 0 &&
                            <StepHorizontalField className="controller-heating-sensor"
                                                 readonly={jointFlowTemperatureSensors.every(x => x.readonly)}
                                                 label={this.renderLabel(1, 'jointFlowTemperatureSensor')}>
                                <div className="row row-no-outer-gutter w-100 left-0">
                                    {jointFlowTemperatureSensors.map(x => (
                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(x)}
                                        </div>
                                    ))}
                                </div>
                            </StepHorizontalField>}
                        {jointReturnTemperatureSensors.length > 0 &&
                            <StepHorizontalField className="controller-heating-sensor"
                                                 readonly={jointReturnTemperatureSensors.every(x => x.readonly)}
                                                 label={this.renderLabel(1, 'jointReturnTemperatureSensor')}>
                                <div className="row row-no-outer-gutter w-100 left-0">
                                    {jointReturnTemperatureSensors.map(x => (
                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(x)}
                                        </div>
                                    ))}
                                </div>
                            </StepHorizontalField>}
                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={temperatureSensorPrimaryReturnReadonly}
                                             label={this.renderPrimarySideEquipmentHeatingLabel(1, 'temperatureSensorPrimaryReturn')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.temperatureSensorPrimaryReturn1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.temperatureSensorPrimaryReturn2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.temperatureSensorPrimaryReturn3)}
                                </div>
                            </div>
                        </StepHorizontalField>
                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={this.fields.outdoorTemperatureSensor.readonly}
                                             label={this.fields.outdoorTemperatureSensor.label}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.outdoorTemperatureSensor)}
                                </div>
                            </div>
                        </StepHorizontalField>
                        <div className="configuration-editor-heating-fields-separator"></div>
                        <StepHorizontalField label=''>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderDHWLabel()}
                                </div>
                            </div>
                        </StepHorizontalField>
                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={this.fields.dhwFlowTemperatureSensor.readonly}
                                             label={this.fields.dhwFlowTemperatureSensor.label}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.dhwFlowTemperatureSensor)}
                                </div>
                            </div>
                        </StepHorizontalField>
                        <StepHorizontalField className="controller-heating-sensor"
                                             readonly={this.fields.dhwCircularTemperatureSensor.readonly}
                                             label={this.fields.dhwCircularTemperatureSensor.label}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.dhwCircularTemperatureSensor)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        {primarySideEquipmentVisible && (
                            <React.Fragment>
                                <div className="configuration-editor-heating-fields-separator"></div>
                                <StepHorizontalField label=''>
                                    <div className="row row-no-outer-gutter w-100 left-0">

                                        <div className="column-4-nopad">
                                            <div className="configuration-editor-controller-heating-label">
                                                {__('Primary')}
                                            </div>
                                        </div>
                                    </div>
                                </StepHorizontalField>
                                <StepHorizontalField className="controller-heating-sensor"
                                                     readonly={this.fields.tedhFlow.readonly}
                                                     label={this.fields.tedhFlow.label}>
                                    <div className="row row-no-outer-gutter w-100 left-0">
                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(this.fields.tedhFlow)}
                                        </div>
                                    </div>
                                </StepHorizontalField>
                                <StepHorizontalField className="controller-heating-sensor"
                                                     readonly={this.fields.tedhRet.readonly}
                                                     label={this.fields.tedhRet.label}>
                                    <div className="row row-no-outer-gutter w-100 left-0">
                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(this.fields.tedhRet)}
                                        </div>
                                    </div>
                                </StepHorizontalField>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </ExpandableContainer>
        )
    }

    renderPressureSensorsSection = () => {
        let showReturnPressureSensor = [this.fields.returnPressureSensor1, this.fields.returnPressureSensor2, this.fields.returnPressureSensor3].some(x => x.visible);
        let showDifferentialPressureSensor = [this.fields.differentialPressureSensor1, this.fields.differentialPressureSensor2, this.fields.differentialPressureSensor3].some(x => x.visible);

        if (!showReturnPressureSensor && !showDifferentialPressureSensor) {
            return <React.Fragment></React.Fragment>
        }

        return (
            <ExpandableContainer label={__('Pressure sensors')}>
                <div className="row row-no-outer-gutter">
                    <div className="column-12 column-xs-12 sensors">

                        <StepHorizontalField label='' className="controller-heating-sensor">
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(1)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(2)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        {showReturnPressureSensor && (
                            <div className="exp-section">
                                <StepHorizontalField className="controller-heating-sensor"
                                                     label={this.renderLabel(1, 'returnPressureSensor')}>
                                    <div className="row row-no-outer-gutter w-100 left-0">
                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(this.fields.returnPressureSensor1)}
                                        </div>

                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(this.fields.returnPressureSensor2)}
                                        </div>

                                        <div className="column-4-nopad">
                                            {this.renderFieldv2(this.fields.returnPressureSensor3)}
                                        </div>
                                    </div>
                                </StepHorizontalField>
                            </div>
                        )}
                        {showDifferentialPressureSensor && <StepHorizontalField className="controller-heating-sensor"
                                                                                label={this.fields.differentialPressureSensor1.label}>
                            <div className="row row-no-outer-gutter w-100">
                                <div className="column-4-nopad">
                                    {this.fields.differentialPressureSensor1.visible && this.renderFieldv2(this.fields.differentialPressureSensor1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.fields.differentialPressureSensor2.visible && this.renderFieldv2(this.fields.differentialPressureSensor2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.fields.differentialPressureSensor3.visible && this.renderFieldv2(this.fields.differentialPressureSensor3)}
                                </div>
                            </div>
                        </StepHorizontalField>}
                    </div>
                </div>
            </ExpandableContainer>
        )
    }

    renderThermometers = () => {
        const dhwVisible = [this.fields.dhwFlowThermometer.visible, this.fields.dhwCircularThermometer.visible, this.fields.coldWaterThermometer.visible].some(x => x);

        return (
            <ExpandableContainer label={__('Thermometers')}>

                <div className="product-checkbox margin-left">
                    {this.renderFieldv2(this.fields.selectAllThermometers)}
                </div>

                <div className="row row-no-outer-gutter">
                    <div className="column-12 column-xs-12 sensors">
                        <StepHorizontalField label='' className="controller-heating-sensor">
                            <div className="row row-no-outer-gutter w-100 left-0">

                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(1)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(2)}
                                </div>
                                <div className="column-4-nopad">
                                    {this.renderHeatingLabel(3)}
                                </div>
                            </div>
                        </StepHorizontalField>
                        <StepHorizontalField className="controller-heating-sensor"
                                             label={this.renderLabel(1, 'flowThermometer')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowThermometer1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowThermometer2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.flowThermometer3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        <StepHorizontalField className="controller-heating-sensor"
                                             label={this.renderLabel(1, 'returnThermometer')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnThermometer1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnThermometer2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.returnThermometer3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        <StepHorizontalField className="controller-heating-sensor"
                                             label={this.renderPrimarySideEquipmentHeatingLabel(1, 'thermometerPrimaryHeatingReturn')}>
                            <div className="row row-no-outer-gutter w-100 left-0">
                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.thermometerPrimaryHeatingReturn1)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.thermometerPrimaryHeatingReturn2)}
                                </div>

                                <div className="column-4-nopad">
                                    {this.renderFieldv2(this.fields.thermometerPrimaryHeatingReturn3)}
                                </div>
                            </div>
                        </StepHorizontalField>

                        <div className="configuration-editor-heating-fields-separator"></div>
                        <StepHorizontalField label='' visible={dhwVisible}>
                            <div className="row row-no-outer-gutter w-100 left-0">

                                <div className="column-4-nopad">
                                    {this.renderDHWLabel()}
                                </div>
                            </div>
                        </StepHorizontalField>

                        {this.fields.dhwFlowThermometer.visible &&
                            <StepHorizontalField className="controller-heating-sensor"
                                                 readonly={this.fields.dhwFlowThermometer.readonly}
                                                 label={this.fields.dhwFlowThermometer.label}>
                                <div className="row row-no-outer-gutter w-100 left-0">
                                    <div className="column-4-nopad">
                                        {this.renderFieldv2(this.fields.dhwFlowThermometer)}
                                    </div>
                                </div>
                            </StepHorizontalField>}
                        {this.fields.dhwCircularThermometer.visible &&
                            <StepHorizontalField className="controller-heating-sensor"
                                                 readonly={this.fields.dhwCircularThermometer.readonly}
                                                 label={this.fields.dhwCircularThermometer.label}>
                                <div className="row row-no-outer-gutter w-100 left-0">
                                    <div className="column-4-nopad">
                                        {this.renderFieldv2(this.fields.dhwCircularThermometer)}
                                    </div>
                                </div>
                            </StepHorizontalField>}
                        {this.fields.coldWaterThermometer.visible &&
                            <StepHorizontalField className="controller-heating-sensor"
                                                 readonly={this.fields.coldWaterThermometer.readonly}
                                                 label={this.fields.coldWaterThermometer.label}>
                                <div className="row row-no-outer-gutter w-100 left-0">
                                    <div className="column-4-nopad">
                                        {this.renderFieldv2(this.fields.coldWaterThermometer)}
                                    </div>
                                </div>
                            </StepHorizontalField>}
                    </div>
                </div>
            </ExpandableContainer>
        )
    }

    shouldDisplayTemperatureSensors = () => !this.props.model.unitType.isMaxiCompactSymbol.value;

    renderBody(model) {
        return (
            <div className="configuration-editor-controller">
                {this.renderGeneralOptionsSection()}
                {this.shouldDisplayTemperatureSensors() &&
                    this.renderSection(this.fields.temperatureSensorManufacturer,
                        this.fields.flowTemperatureSensor1, this.fields.flowTemperatureSensor2, this.fields.flowTemperatureSensor3,
                        this.fields.returnTemperatureSensor1, this.fields.returnTemperatureSensor2, this.fields.returnTemperatureSensor3,
                        this.fields.jointFlowTemperatureSensor1, this.fields.jointFlowTemperatureSensor2, this.fields.jointFlowTemperatureSensor3,
                        this.fields.jointReturnTemperatureSensor1, this.fields.jointReturnTemperatureSensor2, this.fields.jointReturnTemperatureSensor3,
                        this.fields.temperatureSensorPrimaryReturn1, this.fields.temperatureSensorPrimaryReturn2, this.fields.temperatureSensorPrimaryReturn3,
                        this.fields.outdoorTemperatureSensor, this.fields.dhwFlowTemperatureSensor, this.fields.dhwCircularTemperatureSensor)

                    && this.renderTemperatureSensorsSection()}
                {this.renderPressureSensorsSection()}
                {this.renderSection(
                    this.fields.flowThermometer1,
                    this.fields.flowThermometer2,
                    this.fields.flowThermometer3,
                    this.fields.returnThermometer1,
                    this.fields.returnThermometer2,
                    this.fields.returnThermometer3,
                    this.fields.thermometerPrimaryHeatingReturn1,
                    this.fields.thermometerPrimaryHeatingReturn2,
                    this.fields.thermometerPrimaryHeatingReturn3,
                    this.fields.dhwFlowThermometer,
                    this.fields.dhwCircularThermometer,
                    this.fields.coldWaterThermometer) && this.renderThermometers()}
            </div>
        )
    }

    hasHeatingField = (idx, fieldName) => {
        return (
            this.props.model[`heating${idx}`] &&
            this.props.model[`heating${idx}`][fieldName] &&
            this.props.model[`heating${idx}`][fieldName].visible
        )
    }

    hasPrimarySideEquipmentHeatingField = (idx, fieldName) => {
        if (!this.props.model.primarySideEquipment) {
            return false;
        }

        return (
            this.props.model.primarySideEquipment[`heating${idx}`] &&
            this.props.model.primarySideEquipment[`heating${idx}`][fieldName] &&
            this.props.model.primarySideEquipment[`heating${idx}`][fieldName].visible
        )
    }

    renderHeatingLabel = (idx) => {
        if (this.props.model[`heating${idx}`] !== undefined) {
            return (
                <div className="configuration-editor-controller-heating-label">
                    {this.props.model[`heating${idx}`].name.value}
                </div>);
        }
        return '';
    }

    renderDHWLabel = () => (
        <div className="configuration-editor-controller-heating-label">
            {this.props.model.dhw ? this.props.model.dhw.name.value : ''}
        </div>
    )

    renderLabel = (idx, fieldName) => {
        if (this.hasHeatingField(idx, fieldName)) {
            return this.props.model[`heating${idx}`][fieldName].label
        }

        return ''
    }

    renderPrimarySideEquipmentHeatingLabel = (idx, fieldName) => {
        if (this.hasPrimarySideEquipmentHeatingField(idx, fieldName)) {
            return this.props.model.primarySideEquipment[`heating${idx}`][fieldName].label
        }

        return ''
    }

    renderLabeledHeatingField = (heatingIndex, field) => {
        if (field.visible) {
            return (
                <React.Fragment>
                    <span
                        className="configuration-editor-controller-heating-label heating-name-antioverflow">{this.props.model['heating' + heatingIndex].name.value}</span>
                    {this.renderFieldv2(field)}
                </React.Fragment>
            )
        }

        return <React.Fragment></React.Fragment>
    }

    static getFields(step) {
        const createField = name => new Field(name, step)

        return {
            controllerManufacturerFilter: createField('controllerManufacturerFilter'),
            controlCenter: createField('controlCenter'),
            temperatureSensorManufacturer: createField('temperatureSensorManufacturer'),
            controller: createField('controller'),
            pumpSwitchBox: createField('pumpSwitchBox'),
            upgradedControllerDisplay: createField('upgradedControllerDisplay'),
            addOnOption1: createField('addOnOption1'),
            addOnOption2: createField('addOnOption2'),
            addOnOption3: createField('addOnOption3'),
            addOnOption4: createField('addOnOption4'),
            router: createField('router'),
            referenceTemperatureSensor: createField('referenceTemperatureSensor'),
            refSensCount: createField('refSensCount'),
            analogInputsAvailable: createField('analogInputsAvailable'),

            flowTemperatureSensor1: new CrossReferencedHeatingField('flowTemperatureSensor', step, 1),
            flowTemperatureSensor2: new CrossReferencedHeatingField('flowTemperatureSensor', step, 2),
            flowTemperatureSensor3: new CrossReferencedHeatingField('flowTemperatureSensor', step, 3),

            returnTemperatureSensor1: new CrossReferencedHeatingField('returnTemperatureSensor', step, 1),
            returnTemperatureSensor2: new CrossReferencedHeatingField('returnTemperatureSensor', step, 2),
            returnTemperatureSensor3: new CrossReferencedHeatingField('returnTemperatureSensor', step, 3),

            jointFlowTemperatureSensor1: new CrossReferencedHeatingField('jointFlowTemperatureSensor', step, 1),
            jointFlowTemperatureSensor2: new CrossReferencedHeatingField('jointFlowTemperatureSensor', step, 2),
            jointFlowTemperatureSensor3: new CrossReferencedHeatingField('jointFlowTemperatureSensor', step, 3),

            jointReturnTemperatureSensor1: new CrossReferencedHeatingField('jointReturnTemperatureSensor', step, 1),
            jointReturnTemperatureSensor2: new CrossReferencedHeatingField('jointReturnTemperatureSensor', step, 2),
            jointReturnTemperatureSensor3: new CrossReferencedHeatingField('jointReturnTemperatureSensor', step, 3),

            returnPressureSensor1: new CrossReferencedHeatingField('returnPressureSensor', step, 1),
            returnPressureSensor2: new CrossReferencedHeatingField('returnPressureSensor', step, 2),
            returnPressureSensor3: new CrossReferencedHeatingField('returnPressureSensor', step, 3),

            differentialPressureSensor1: new CrossReferencedHeatingField('differentialPressureSensor', step, 1),
            differentialPressureSensor2: new CrossReferencedHeatingField('differentialPressureSensor', step, 2),
            differentialPressureSensor3: new CrossReferencedHeatingField('differentialPressureSensor', step, 3),

            flowThermometer1: new CrossReferencedHeatingField('flowThermometer', step, 1),
            flowThermometer2: new CrossReferencedHeatingField('flowThermometer', step, 2),
            flowThermometer3: new CrossReferencedHeatingField('flowThermometer', step, 3),

            returnThermometer1: new CrossReferencedHeatingField('returnThermometer', step, 1),
            returnThermometer2: new CrossReferencedHeatingField('returnThermometer', step, 2),
            returnThermometer3: new CrossReferencedHeatingField('returnThermometer', step, 3),

            temperatureSensorPrimaryReturn1: new CrossReferencedPSEField('heating1.temperatureSensorPrimaryReturn', step),
            temperatureSensorPrimaryReturn2: new CrossReferencedPSEField('heating2.temperatureSensorPrimaryReturn', step),
            temperatureSensorPrimaryReturn3: new CrossReferencedPSEField('heating3.temperatureSensorPrimaryReturn', step),

            thermometerPrimaryHeatingReturn1: new CrossReferencedPSEField('heating1.thermometerPrimaryHeatingReturn', step),
            thermometerPrimaryHeatingReturn2: new CrossReferencedPSEField('heating2.thermometerPrimaryHeatingReturn', step),
            thermometerPrimaryHeatingReturn3: new CrossReferencedPSEField('heating3.thermometerPrimaryHeatingReturn', step),

            tedhFlow: new CrossReferencedPSEField('tedhFlow', step),
            tedhRet: new CrossReferencedPSEField('tedhRet', step),

            outdoorTemperatureSensor: createField('outdoorTemperatureSensor'),
            dhwFlowTemperatureSensor: createField('dhwFlowTemperatureSensor'),
            dhwCircularTemperatureSensor: createField('dhwCircularTemperatureSensor'),
            dhwFlowThermometer: createField('dhwFlowThermometer'),
            dhwCircularThermometer: createField('dhwCircularThermometer'),
            coldWaterThermometer: createField('coldWaterThermometer'),

            selectAllThermometers: createField('selectAllThermometers')
        }
    }

    static getStepModel(model) {
        return new StepModel('controller', model.controller)
    }
}